import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeNew from '../views/HomeNew.vue'

import store from "../store";

Vue.use(VueRouter)

const requireAuthenticated = (to, from, next) => {
  store.dispatch("auth/initialize").then(() => {
    if (!store.getters["auth/isAuthenticated"]) {
      next("/login");
    } else {
      next();
    }
  });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch("auth/initialize").then(() => {
    if (store.getters["auth/isAuthenticated"]) {
      next("/");
    } else {
      next();
    }
  });
};

const redirectLogout = (to, from, next) => {
  store.dispatch("auth/logout")
    .catch(() => {})
    .finally(() => next("/"));
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeNew,
    meta: { title: 'Domov' }
  },
  {
    path: '/about',
    name: 'O nas',
    component: Home,
    meta: { title: 'O nás' }
  },
  {
    path: "/login",
    name: "Prihlásenie",
    component: () => import('../views/Login.vue'),
    beforeEnter: requireUnauthenticated,
    meta: { title: 'Prihlásenie' }
  },
  {
    path: "/logout",
    beforeEnter: redirectLogout
  },
  {
    path: "/register",
    name: "Registrácia",
    component: () => import('../views/Register.vue'),
    beforeEnter: requireUnauthenticated,
    meta: { title: 'Registrácia' }
  },
  {
    path: "/register_verify",
    name: "Verifikácia 1",
    component: () => import('../views/RegisterVerify.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Verifikácia' }
  },
  {
    path: "/bank_verify",
    name: "Verifikácia 2",
    component: () => import('../views/BankVerify.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Verifikácia banky' }
  },

  {
    path: "/profile/:tabID",
    name: "Profil",
    component: () => import('../views/Profile.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Môj Profil' }
  },
  {
    path: "/candidate",
    name: "Kandidát prihláška",
    component: () => import('../views/Candidate.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Kandidát prihláška' }
  },
  {
    path: "/member",
    name: "Člen prihláška",
    component: () => import('../views/MemberApplication.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Člen prihláška' }
  },
  {
    path: "/invest",
    name: "Darovanie",
    component: () => import('../views/Invest.vue'),
    meta: { title: 'Darovanie' }
  },
  {
    path: "/list",
    name: "Zoznam",
    component: () => import('../views/List.vue'),
    meta: { title: 'Zoznam' }
  },
  {
    path: "/list_table",
    name: "Zoznam tabuľka",
    component: () => import('../views/ListTable.vue'),
    meta: { title: 'Zoznam tabuľka' }
  },
  {
    path: "/admin/:tabID",
    name: "Administrácia",
    component: () => import('../views/Admin.vue'),
    meta: { title: 'Administrácia' }
  },
  {
    path: "/moderator",
    name: "Moderátor",
    component: () => import('../views/moderator/Moderator.vue'),
    meta: { title: 'Moderátor' }
  },

  {
    path: "/admin/menu",
    name: "Administrácia - Menu",
    component: () => import('../views/admin/Menu.vue'),
    meta: { title: 'Administrácia - Menu' }
  },
  {
    path: "/admin/pages",
    name: "Administrácia - Stránky",
    component: () => import('../views/admin/Pages.vue'),
    meta: { title: 'Administrácia - Stránky' }
  },
  {
    path: '/page/:id',
    name: "Stránka",
    component: () => import('../views/Page.vue'),
    meta: { title: 'Stránka' }
  },
  {
    path: '/members',
    name: "Zoznam členov",
    component: () => import('../views/MembersList.vue'),
    meta: { title: 'Zoznam členov' }
  },
  {
    path: '/referendum',
    name: "Referendá",
    component: () => import('../views/Referendum.vue'),
    meta: { title: 'Referendá' }
  },
  {
    path: '/polls',
    name: "Referendá",
    component: () => import('../views/Referendum.vue'),
    meta: { title: 'Ankety' }
  },
  {
    path: '/question_choose',
    name: "Výbery otázok",
    component: () => import('../views/QuestionChoose.vue'),
    meta: { title: 'Výbery otázok' }
  },
  {
    path: '/survey/:surveyID',
    name: "Prieskum",
    component: () => import('../views/Survey.vue'),
    meta: { title: 'Prieskum' }
  },

  {
    path: '/survey_discussion/:surveyID/:partyID',
    name: "Diskusia prieskumy",
    component: () => import('../views/SurveyDiscussion.vue'),
    meta: { title: 'Diskusia prieskumy' }
  },


  {
    path: '/referendum/:referendumID/question/:questionID/discussion',
    name: "Diskusia k referendum",
    component: () => import('../views/ReferendumDiscussion.vue'),
    meta: { title: 'Diskusia k referendum' }
  },

  {
    path: '/poll_category/:categoryID/',
    name: "Kategoria ankety",
    component: () => import('../views/poll/PollCategory.vue'),
    meta: { title: 'Kategória ankety' }
  },

  {
    path: '/poll_category/:categoryID/poll/:pollID',
    name: "Rubrika",
    component: () => import('../views/poll/Poll.vue'),
    props: (route) => ({
      categoryID: Number(route.params.categoryID),
      pollID: Number(route.params.pollID)
    }),
    meta: { title: 'Rubrika' }
  },
  {
    path: '/poll/:categoryID/:pollID/question/:questionID',
    name: "Rubrika (detail)",
    component: () => import('../views/poll/Poll.vue'),
    props: (route) => ({
      categoryID: Number(route.params.categoryID),
      pollID: Number(route.params.pollID),
      questionID: Number(route.params.questionID)
    }),
    meta: { title: 'Rubrika - detail' }
  },

  {
    path: '/poll_question/:questionID',
    name: "Otázka",
    component: () => import('../views/poll/PollQuestion.vue'),
    meta: { title: 'Otázka' }
  },

  {
    path: '/poll_category/:categoryID/poll_sub_questions/:questionID',
    name: "Otázka",
    component: () => import('../views/poll/PollSubQuestions.vue'),
    meta: { title: 'Otázka (podotázky)' }
  },

  {
    path: '/poll_question_discussion/:questionID',
    name: "Diskusia general",
    component: () => import('../views/poll/PollDiscussion.vue'),
    meta: { title: 'Diskusia' }
  },

  {
    path: '/poll/:categoryID/:pollID/question/:questionID/discussion',
    name: "Diskusia (detail)",
    component: () => import('../views/poll/PollDiscussion.vue'),
    meta: { title: 'Diskusia - detail' }
  },


  {
    path: '/password_reset',
    name: "Zabudnuté heslo",
    component: () => import('../views/LostPassword.vue'),
    meta: { title: 'Zabudnuté heslo' }
  },

  {
    path: '/password_reset_final',
    name: "Zabudnuté heslo final",
    component: () => import('../views/LostPasswordFinal.vue'),
    meta: { title: 'Zabudnuté heslo - dokončenie' }
  },

  {
    path: '/logo',
    name: "Logo",
    component: () => import('../views/Logo.vue'),
    meta: { title: 'Logo' }
  },

  {
    path: '/clocks',
    name: "Hodiny",
    component: () => import('../views/ClocksPage.vue'),
    meta: { title: 'Hodiny' }
  },
  {
    path: '/news',
    name: "Novinky",
    component: () => import('../views/News.vue'),
    meta: { title: 'Novinky' }
  },
  {
    path: '/notifications',
    name: "Upozornenia",
    component: () => import('../views/notifications/NotificationCenter.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Upozornenia' }
  },
  {
    path: '/settings/notifications',
    name: "Nastavenia upozornení",
    component: () => import('../views/notifications/NotificationSettings.vue'),
    beforeEnter: requireAuthenticated,
    meta: { title: 'Nastavenia upozornení' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  const baseTitle = 'Naše Hnutie';
  const pageTitle = to.meta && to.meta.title ? to.meta.title : to.name;

  if (pageTitle && pageTitle !== 'Home') {
    document.title = `${pageTitle} | ${baseTitle}`;
  } else {
    document.title = baseTitle;
  }
});

export default router
